import { render, staticRenderFns } from "./PermissionsTeamManager.vue?vue&type=template&id=7b84403a&"
import script from "./PermissionsTeamManager.vue?vue&type=script&lang=js&"
export * from "./PermissionsTeamManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports